module.exports = __webpack_public_path__ + "img/var_02_asset.8c9fe5cb.png";